module.exports = __webpack_public_path__ + "static/media/10_000_Racoons.6b685cff.webp";